import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import CommentListing from "components/CommentListing/CommentListing";
import FiveStartIconForRate from "components/FiveStartIconForRate/FiveStartIconForRate";
import GuestsInput from "components/HeroSearchForm/GuestsInput";
import StartRating from "components/StartRating/StartRating";
import useWindowSize from "hooks/useWindowResize";
import moment from "moment";
import {
  DayPickerSingleDateController,
  isInclusivelyAfterDay,
} from "react-dates";
import Avatar from "shared/Avatar/Avatar";
import Badge from "shared/Badge/Badge";
import ButtonCircle from "shared/Button/ButtonCircle";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import Input from "shared/Input/Input";
import NcImage from "shared/NcImage/NcImage";
import LikeSaveBtns from "./LikeSaveBtns";
import ModalPhotos from "./ModalPhotos";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
import MobileFooterSticky from "./MobileFooterSticky";
// Redux Toolkit
import { useSelector, useDispatch } from "react-redux";
import { openModal, closeModal, setAll } from "features/bookingSlice";
import { useNavigate, useParams } from "react-router-dom";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import CustomMarker from "components/ReactLeaflet/CustomMarker";
import calculateTotal from "utils/calculateTotal";

import ExperiencesDateSingleInput from "components/HeroSearchForm/ExperiencesDateSingleInput";
import { toast } from "react-toastify";
import userApis from "apis/users";
import { setLoading } from "features/auth";

// const PHOTOS: string[] = [
//   "https://images.pexels.com/photos/6129967/pexels-photo-6129967.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
//   "https://images.pexels.com/photos/7163619/pexels-photo-7163619.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//   "https://images.pexels.com/photos/6527036/pexels-photo-6527036.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//   "https://images.pexels.com/photos/6969831/pexels-photo-6969831.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//   "https://images.pexels.com/photos/6438752/pexels-photo-6438752.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//   "https://images.pexels.com/photos/1320686/pexels-photo-1320686.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//   "https://images.pexels.com/photos/261394/pexels-photo-261394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//   "https://images.pexels.com/photos/2861361/pexels-photo-2861361.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
//   "https://images.pexels.com/photos/2677398/pexels-photo-2677398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
// ];

const Amenities_demos = [
  { name: "la-key", icon: "la-key" },
  { name: "la-luggage-cart", icon: "la-luggage-cart" },
  { name: "la-shower", icon: "la-shower" },
  { name: "la-smoking", icon: "la-smoking" },
  { name: "la-snowflake", icon: "la-snowflake" },
  { name: "la-spa", icon: "la-spa" },
  { name: "la-suitcase", icon: "la-suitcase" },
  { name: "la-suitcase-rolling", icon: "la-suitcase-rolling" },
  { name: "la-swimmer", icon: "la-swimmer" },
  { name: "la-swimming-pool", icon: "la-swimming-pool" },
  { name: "la-tv", icon: "la-tv" },
  { name: "la-umbrella-beach", icon: "la-umbrella-beach" },
  { name: "la-utensils", icon: "la-utensils" },
  { name: "la-wheelchair", icon: "la-wheelchair" },
  { name: "la-wifi", icon: "la-wifi" },
  { name: "la-baby-carriage", icon: "la-baby-carriage" },
  { name: "la-bath", icon: "la-bath" },
  { name: "la-bed", icon: "la-bed" },
  { name: "la-briefcase", icon: "la-briefcase" },
  { name: "la-car", icon: "la-car" },
  { name: "la-cocktail", icon: "la-cocktail" },
  { name: "la-coffee", icon: "la-coffee" },
  { name: "la-concierge-bell", icon: "la-concierge-bell" },
  { name: "la-dice", icon: "la-dice" },
  { name: "la-dumbbell", icon: "la-dumbbell" },
  { name: "la-hot-tub", icon: "la-hot-tub" },
  { name: "la-infinity", icon: "la-infinity" },
];

const ListingStayDetailPage = ({ className = "", isPreviewMode }) => {
  const { listingId } = useParams();
  const [listing, setListing] = useState(null);
  const [datesDetails, setDatesDetails] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [blockedDates, setBlockedDates] = useState([]);
  const [firstSlotBooked, setFirstSlotBooked] = useState([]);
  const [secondSlotBooked, setSecondSlotBooked] = useState([]);

  const jwt = useSelector((state) => state?.auth?.jwt);
  const api = new userApis(jwt);

  const {
    address,
    author,
    title,
    reviewCount,
    reviewStart,
    bathrooms,
    bedrooms,
    maxGuests,
    date,
    price,
    galleryImgs,
    listingCategory,
    has3D,
    slots,
    matterportURL,
    map /* other properties */,
    stayDescription,
    featuredImage,
    comments,
  } = listing ?? {};

  const position = [map?.lat ?? 0, map?.lng ?? 0];

  const [isOpen, setIsOpen] = useState(false);
  const [slotsState, setSlotsState] = useState(slots);
  const [openFocusIndex, setOpenFocusIndex] = useState(0);
  const [focusedInputSectionCheckDate, setFocusedInputSectionCheckDate] =
    useState("startDate");
  const [selectedDate, setSelectedDate] = useState();
  const [slot, setSlot] = useState(0);

  let [isOpenModalAmenities, setIsOpenModalAmenities] = useState(false);
  const bookingState = useSelector((state) => state.booking);
  const auth = useSelector((state) => state.auth);

  // Redux Toolkit

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // Redux Toolkit
  const windowSize = useWindowSize();

  const getDaySize = () => {
    if (windowSize.width <= 375) {
      return 34;
    }
    if (windowSize.width <= 500) {
      return undefined;
    }
    if (windowSize.width <= 1280) {
      return 56;
    }
    return 48;
  };

  async function getDatesDetails() {
    try {
      dispatch(setLoading(true));
      const dateDetailsResponse = await api.getDateDetails(listingId);
      setDatesDetails(dateDetailsResponse);
      const blocked = [],
        firstSlotBooked = [],
        secondSlotBooked = [];
      dateDetailsResponse.forEach((dateObj) => {
        if (dateObj.slots?.length >= slots?.length) {
          blocked.push(moment(dateObj.date));
        } else if (dateObj.slots?.includes(0)) {
          firstSlotBooked.push(moment(dateObj.date));
        } else {
          secondSlotBooked.push(moment(dateObj.date));
        }
      });
      setBlockedDates(blocked);
      setFirstSlotBooked(firstSlotBooked);
      setSecondSlotBooked(secondSlotBooked);
      dispatch(setLoading(false));
    } catch (error) {
      toast.error("Error fetching dates:" + error);
    } finally {
      dispatch(setLoading(false));
    }
  }

  useEffect(() => {
    // Simulate data retrieval from JSON file using the listingId
    const fetchedListing = DEMO_STAY_LISTINGS.find(
      // Removed Number() conversion
      (listing) => listing.id === listingId
    );
    // console.log(DEMO_STAY_LISTINGS)

    setListing(fetchedListing);
  }, [listingId]);

  useEffect(() => {
    getDatesDetails(listingId);
  }, [listing]);

  function closeModalAmenities() {
    setIsOpenModalAmenities(false);
  }

  function openModalAmenities() {
    setIsOpenModalAmenities(true);
  }

  const handleOpenModal = (index) => {
    setIsOpen(true);
    setOpenFocusIndex(index);
  };

  const isDayBlocked = (day) =>
    blockedDates.some((blockedDate) => blockedDate.isSame(day, "day"));

  const renderDayContents = (day) => {
    const isFirstSlotBooked = firstSlotBooked.find((date) =>
      date.isSame(day, "day")
    );
    const isSecondSlotBooked = secondSlotBooked.find((date) =>
      date.isSame(day, "day")
    );
    const isBlocked = blockedDates.find((date) => date.isSame(day, "day"));
    let colorClass = "";
    if (isBlocked) {
      colorClass = "text-[#D8DBE0]";
    } else if (isFirstSlotBooked) {
      colorClass = "text-red-500";
    } else if (isSecondSlotBooked) {
      colorClass = "text-blue-500";
    }

    return (
      <div
        className={`flex items-center justify-center w-full h-full rounded-full ${colorClass}`}
      >
        {day.date()}
      </div>
    );
  };

  const handleCloseModal = () => setIsOpen(false);

  // Matterport
  // const [showModal, setShowModal] = useState(false);
  const showModal = bookingState.showModal;

  useEffect(() => {
    const dateSelected = datesDetails.find((dateObj) => {
      const date = moment(dateObj?.date);
      return selectedDate?.isSame(date, "day");
    });
    if (dateSelected) {
      setSlotsState(
        slots?.map((slotObj, i) => {
          return {
            ...slotObj,
            isBlocked: dateSelected?.slots?.includes(i),
          };
        }) || slots
      );
    } else {
      setSlotsState(slots);
    }
    setSlot(undefined);
  }, [selectedDate]);

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap !space-y-6">
        {/* 1 */}
        <div className="flex justify-between items-center">
          <Badge name={listingCategory?.name} />
          {/* {has3D && <ThreeDBadge onClick={HandleshowModal} />} */}

          <LikeSaveBtns />
        </div>

        {/* 2 */}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold">
          {title && title}
        </h2>

        {/* Modal */}
        {/* {showModal && (
          <div
            className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-75 hover:bg-opacity-50 flex items-center justify-center  z-50 "
            onClick={HideModal}
          >
            <div className="relative w-full h-full max-w-3xl max-h-3xl z-50">
              <button
                className="absolute top-0 right-0 p-4   bg-black bg-opacity-50 hover:bg-opacity-50 rounded-full px-2 py-2 mt-6 mr-6 text-white  cursor-pointer"
                onClick={HideModal}
              >
                <XMarkIcon className="h-8 w-8" />
              </button>
              <iframe
                src={`https://my.matterport.com/show/?m=${matterportURL}`}
                title="3D Tour"
                width="100%"
                height="100%"
                frameBorder="0"
                // className="z-50"
              />
            </div>
          </div>
        )} */}

        {/* 3 */}
        <div className="flex items-center space-x-4">
          <StartRating reviewCount={reviewCount} reviewStart={reviewStart} />
          <span>·</span>
          <span>
            <i className="las la-map-marker-alt"></i>
            <span className="ml-1">{address && address}</span>
          </span>
        </div>

        {/* 4 */}
        {/* <div className="flex items-center">
          <Avatar
            author={author}
            hasChecked
            sizeClass="h-10 w-10"
            radius="rounded-full"
          />
          <span className="ml-2.5 text-neutral-500 dark:text-neutral-400">
            Hosted by{" "}
            <span className="text-neutral-900 dark:text-neutral-200 font-medium">
              {author?.displayName}
            </span>
          </span>
        </div> */}

        {/* 5 */}
        <div className="w-full border-b border-neutral-100 dark:border-neutral-700" />

        {/* 6 */}
        <div className="flex items-center justify-between xl:justify-start space-x-8 xl:space-x-12 text-sm text-neutral-700 dark:text-neutral-300">
          <div className="flex items-center space-x-3 ">
            <i className=" las la-user text-2xl "></i>
            <span className="">
              {maxGuests && maxGuests}{" "}
              <span className="hidden sm:inline-block">guests</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-bed text-2xl"></i>
            <span className=" ">
              {bedrooms && bedrooms}{" "}
              <span className="hidden sm:inline-block">beds</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-bath text-2xl"></i>
            <span className=" ">
              {bathrooms && bathrooms}{" "}
              <span className="hidden sm:inline-block">baths</span>
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <i className=" las la-door-open text-2xl"></i>
            <span className=" ">
              {bedrooms && bedrooms}{" "}
              <span className="hidden sm:inline-block">bedrooms</span>
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderSection2 = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Information</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="text-neutral-6000 dark:text-neutral-300">
          <span>{stayDescription}</span>
        </div>
      </div>
    );
  };

  const renderSection3 = () => {
    return (
      <div className="listingSection__wrap">
        <div>
          <h2 className="text-2xl font-semibold">Amenities </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            About the property's amenities and services
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* 6 */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 text-sm text-neutral-700 dark:text-neutral-300 ">
          {Amenities_demos.filter((_, i) => i < 12).map((item) => (
            <div key={item.name} className="flex items-center space-x-3">
              <i className={`text-3xl las ${item.icon}`}></i>
              <span className=" ">{item.name}</span>
            </div>
          ))}
        </div>

        {/* ----- */}
        <div className="w-14 border-b border-neutral-200"></div>
        <div>
          <ButtonSecondary onClick={openModalAmenities}>
            View more 20 amenities
          </ButtonSecondary>
        </div>
        {renderMotalAmenities()}
      </div>
    );
  };

  const renderMotalAmenities = () => {
    return (
      <Transition appear show={isOpenModalAmenities} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          onClose={closeModalAmenities}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-40" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block py-8 h-screen w-full max-w-4xl">
                <div className="inline-flex pb-2 flex-col w-full text-left align-middle transition-all transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl h-full">
                  <div className="relative flex-shrink-0 px-6 py-4 border-b border-neutral-200 dark:border-neutral-800 text-center">
                    <h3
                      className="text-lg font-medium leading-6 text-gray-900"
                      id="headlessui-dialog-title-70"
                    >
                      Amenities
                    </h3>
                    <span className="absolute left-3 top-3">
                      <ButtonClose onClick={closeModalAmenities} />
                    </span>
                  </div>
                  <div className="px-8 overflow-auto text-neutral-700 dark:text-neutral-300 divide-y divide-neutral-200">
                    {Amenities_demos.filter((_, i) => i < 1212).map((item) => (
                      <div
                        key={item.name}
                        className="flex items-center py-2.5 sm:py-4 lg:py-5 space-x-5 lg:space-x-8"
                      >
                        <i
                          className={`text-4xl text-neutral-6000 las ${item.icon}`}
                        ></i>
                        <span>{item.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const renderSection4 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Room Rates </h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Prices may increase on weekends or holidays
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* CONTENT */}
        <div className="flow-root">
          <div className="text-sm sm:text-base text-neutral-6000 dark:text-neutral-300 -mb-4">
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Monday - Thursday</span>
              <span>$199</span>
            </div>
            <div className="p-4  flex justify-between items-center space-x-4 rounded-lg">
              <span>Monday - Thursday</span>
              <span>$199</span>
            </div>
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Friday - Sunday</span>
              <span>$219</span>
            </div>
            <div className="p-4 flex justify-between items-center space-x-4 rounded-lg">
              <span>Rent by month</span>
              <span>-8.34 %</span>
            </div>
            <div className="p-4 bg-neutral-100 dark:bg-neutral-800 flex justify-between items-center space-x-4 rounded-lg">
              <span>Minimum number of nights</span>
              <span>1 night</span>
            </div>
            <div className="p-4 flex justify-between items-center space-x-4 rounded-lg">
              <span>Max number of nights</span>
              <span>90 nights</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleIsDayBlocked = (day) => {
    return datesDetails
      ?.filter((dateObj) => dateObj?.slots?.length == 2)
      ?.some((dateObj) => {
        const dateMoment = moment(dateObj.date);
        return dateMoment.isSame(day, "day");
      });
  };

  const renderSectionCheckIndate = () => {
    return (
      <div className="listingSection__wrap overflow-hidden">
        {/* HEADING */}
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* CONTENT */}

        <div className="listingSection__wrap__DayPickerRangeController flow-root">
          <div className="-mx-4 sm:mx-auto xl:mx-[-22px]">
            <DayPickerSingleDateController
              date={selectedDate}
              onDateChange={(date) => {
                setSelectedDate(date);
              }}
              onFocusChange={() => {}}
              focused={true}
              initialVisibleMonth={null}
              numberOfMonths={windowSize.width < 1280 ? 1 : 2}
              daySize={getDaySize()}
              hideKeyboardShortcutsPanel
              isOutsideRange={(day) => !isInclusivelyAfterDay(day, moment())}
              isDayBlocked={isDayBlocked}
              renderDayContents={renderDayContents}
            />
          </div>
        </div>
      </div>
    );
  };

  const combinedRender = () => {
    return (
      <div className="listingSection__wrap overflow-hidden  space-y-0">
        {/* HEADING */}
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* CONTENT */}
        <div className="p-1">
          <h1 className="text-xl font-bold mb-4">Slot Booking Status</h1>
          <div className="">
            <div className="flex items-center space-x-2">
              {/* Dot */}
              <div className={`w-4 h-4 rounded-full bg-red-500`}></div>
              {/* Label */}
              <span className="text-sm font-medium text-gray-700">
                Morning Slot Booked
              </span>
            </div>
            <div className="flex items-center space-x-2">
              {/* Dot */}
              <div className={`w-4 h-4 rounded-full bg-blue-500`}></div>
              {/* Label */}
              <span className="text-sm font-medium text-gray-700">
                Evening Slot Booked
              </span>
            </div>
          </div>
        </div>

        <div className="listingSection__wrap__DayPickerRangeController flow-root space-y-0">
          {renderSectionCheckIndate()}
        </div>
        <div className="flex-1 listingExperiencesDetailPage__GuestsInput">
          <GuestsInput
            fieldClassName="p-4"
            onChange={setSlot}
            defaultValue={slot}
            hasButtonSubmit={false}
            value={slots?.[slot]}
            slots={slotsState || slots}
          />
        </div>
      </div>
    );
  };

  const renderSection6 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">
          Reviews ({reviewCount} reviews)
        </h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

        {/* Content */}
        <div className="space-y-5">
          <FiveStartIconForRate iconClass="w-6 h-6" className="space-x-0.5" />
          <div className="relative">
            <Input
              fontClass=""
              sizeClass="h-16 px-4 py-3"
              rounded="rounded-3xl"
              placeholder="Share your thoughts ..."
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
            <ButtonCircle
              className="absolute right-2 top-1/2 transform -translate-y-1/2"
              size=" w-12 h-12 "
              onClick={() => {
                setInputValue("");
                toast.info("Review will be posted soon!!");
              }}
            >
              <ArrowRightIcon className="w-5 h-5" />
            </ButtonCircle>
          </div>
        </div>

        {/* comment */}
        <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
          {comments &&
            comments.map((comment) => (
              <CommentListing className="py-8" data={comment} />
            ))}
          {/* <div className="pt-8">
            <ButtonSecondary>
              {reviewCount && reviewCount} more reviews
            </ButtonSecondary>
          </div> */}
        </div>
      </div>
    );
  };

  const renderSection7 = () => {
    if (!map) {
      // Position data not available, render a loading state or something else
      return <p>Loading map...</p>;
    }
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <div>
          <h2 className="text-2xl font-semibold">Location</h2>
          <span className="block mt-2 text-neutral-500 dark:text-neutral-400 z-0">
            {/* San Diego, CA, United States of America (SAN-San Diego Intl.) */}
            {address && address}
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* MAP */}

        {!showModal && (
          <div className="aspect-w-5 aspect-h-5 sm:aspect-h-3 z-0">
            <div
              className="rounded-xl 
          overflow-hidden
          "
            >
              <MapContainer
                style={{ height: "100vh" }}
                center={position}
                zoom={15}
                scrollWheelZoom={true}
              >
                <TileLayer
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors '
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <CustomMarker
                  key={listing?.id}
                  position={position}
                  color="blue"
                ></CustomMarker>
              </MapContainer>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderSection8 = () => {
    return (
      <div className="listingSection__wrap">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold">Things to know</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Cancellation policy</h4>
          <span className="block mt-3 text-neutral-500 dark:text-neutral-400">
            Refund 50% of the booking value when customers cancel the bookings
            before 48 hours of the booking day. <br />
          </span>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        <div>
          <h4 className="text-lg font-semibold">Booking Slots</h4>
          <div className="mt-3 text-neutral-500 dark:text-neutral-400 max-w-md text-sm sm:text-base">
            <div className="flex space-x-10 justify-between p-3 bg-neutral-100 dark:bg-neutral-800 rounded-lg">
              <span>Day Slot</span>
              <span>10:00 am - 05:00 pm</span>
            </div>
            <div className="flex space-x-10 justify-between p-3">
              <span>Night Slot</span>
              <span>07:00 pm - 12:00 pm</span>
            </div>
          </div>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700" />

        {/* CONTENT */}
        {/* <div>
          <h4 className="text-lg font-semibold">Special Note</h4>
          <div className="prose sm:prose">
            <ul className="mt-3 text-neutral-500 dark:text-neutral-400 space-y-2">
              <li>
                Ban and I will work together to keep the landscape and
                environment green and clean by not littering, not using
                stimulants and respecting people around.
              </li>
              <li>Do not sing karaoke past 11:30</li>
            </ul>
          </div>
        </div> */}
      </div>
    );
  };

  const handleReserve = () => {
    dispatch(
      setAll({
        date: selectedDate.format("DD MMM"),
        slotId: slot,
        slot: slotsState[slot]?.name,
        pic: featuredImage,
        title,
        description: stayDescription,
        price,
        placeId: listingId,
        isoDate: selectedDate.format("YYYY-MM-DD"),
      })
    );
    navigate(auth.jwt ? "/checkout" : "/login");
  };

  const renderSidebar = () => {
    return (
      <div className="listingSectionSidebar__wrap shadow-xl">
        PRICE
        <div className="flex justify-between">
          <span className="text-3xl font-semibold">
            {price && price}
            <span className="ml-1 text-base font-normal text-neutral-500 dark:text-neutral-400">
              /slot
            </span>
          </span>
          <StartRating reviewCount={reviewCount} reviewStart={reviewStart} />
        </div>
        {/* FORM */}
        <form className="flex flex-col sm:flex-row border divide-y sm:divide-y-0 sm:divide-x divide-neutral-200 dark:divide-neutral-700 border-neutral-200 dark:border-neutral-700 rounded-3xl ">
          <div className="flex-1">
            <ExperiencesDateSingleInput
              defaultValue={selectedDate}
              anchorDirection={"right"}
              fieldClassName="p-4"
              className="h-full"
              onChange={(date) => {
                setSelectedDate(date);
              }}
              isDayBlocked={isDayBlocked}
              renderDayContents={renderDayContents}
            />
          </div>
          <div className="flex-1 listingExperiencesDetailPage__GuestsInput">
            <GuestsInput
              fieldClassName="p-4"
              onChange={setSlot}
              defaultValue={slotsState?.reduce((defaultValue, slotObj, i) => {
                defaultValue = slotObj?.isBlocked ? defaultValue : i;
                return defaultValue;
              }, 0)}
              hasButtonSubmit={false}
              value={slotsState?.[slot]}
              slots={slotsState}
            />
          </div>
        </form>
        {/* SUM */}
        <div className="flex flex-col space-y-4">
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Booking Amount</span>
            <span>{price ? `${price}` : "N/A"}</span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Taxs and Service charge</span>
            <span>Rs. 0</span>
          </div>
          <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
          <div className="flex justify-between font-semibold">
            <span>Total</span>
            <span>{price ? `${price}` : "N/A"}</span>
          </div>
        </div>
        {/* SUBMIT */}
        <ButtonPrimary onClick={handleReserve}>Reserve</ButtonPrimary>
      </div>
    );
  };

  console.log(galleryImgs);

  return (
    <div
      className={`ListingDetailPage nc-ListingStayDetailPage ${className}`}
      data-nc-id="ListingStayDetailPage"
    >
      {/* SINGLE HEADER */}
      <>
        <header className="container 2xl:px-14 rounded-md sm:rounded-xl">
          <div className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2">
            <div
              className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer"
              onClick={() => handleOpenModal(0)}
            >
              {galleryImgs?.[0] && (
                <NcImage
                  containerClassName="absolute inset-0"
                  className="object-cover w-full h-full rounded-md sm:rounded-xl"
                  src={"/svgs/" + galleryImgs?.[0]}
                />
              )}
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>
            {galleryImgs?.map(
              (
                item,
                index // Use galleryImgs instead of PHOTOS
              ) => (
                <div
                  key={index}
                  className={`relative rounded-md sm:rounded-xl overflow-hidden ${
                    index >= 3 ? "hidden sm:block" : ""
                  }`}
                >
                  {item && (
                    <NcImage
                      containerClassName="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5"
                      className="object-cover w-full h-full rounded-md sm:rounded-xl "
                      src={"/svgs/" + item}
                    />
                  )}
                  {/* OVERLAY */}
                  <div
                    className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                    onClick={() => handleOpenModal(index + 1)}
                  />
                </div>
              )
            )}

            <div
              className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 cursor-pointer hover:bg-neutral-200 z-10"
              onClick={() => handleOpenModal(0)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.5}
                  d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                />
              </svg>
              <span className="ml-2 text-neutral-800 text-sm font-medium">
                Show all photos
              </span>
            </div>
          </div>
        </header>
        {/* MODAL PHOTOS */}
        <ModalPhotos
          imgs={galleryImgs}
          isOpen={isOpen}
          onClose={handleCloseModal}
          initFocus={openFocusIndex}
          uniqueClassName="nc-ListingStayDetailPage-modalPhotos"
        />
      </>

      {/* MAIn */}
      <main className="container relative z-10 mt-11 flex flex-col lg:flex-row ">
        {/* CONTENT */}
        <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:space-y-10 lg:pr-10">
          {renderSection1()}
          {renderSection2()}
          {renderSection3()}
          {/* {renderSection4()} */}
          {/* {!isPreviewMode && renderSectionCheckIndate()} */}
          {/* {renderSection5()} */}
          {renderSection6()}
          {renderSection7()}
          {renderSection8()}
        </div>

        {/* SIDEBAR */}
        <div className="hidden lg:block flex-grow mt-14 lg:mt-0">
          <div className="sticky top-28">{renderSidebar()}</div>
        </div>
      </main>

      {/* STICKY FOOTER MOBILE */}
      {!isPreviewMode && (
        <MobileFooterSticky
          component={combinedRender}
          price={price}
          selectedOption={
            slotsState?.[slot]?.name
              ? selectedDate.format("DD MMM") + " @ " + slotsState[slot]?.name
              : "Please select a date and slot"
          }
          handleReserve={handleReserve}
        />
      )}

      {/* OTHER SECTION */}
      {!isPreviewMode && (
        <div className="container py-24 lg:py-32">
          {/* <SectionSubscribe2 className="pt-24 lg:pt-32" /> */}
        </div>
      )}
    </div>
  );
};

export default ListingStayDetailPage;
